<template>
    <vs-row>
        <vs-row vs-justify="space-between" class="my-5 mx-4">
            <vs-dropdown>
              <vs-button id="bgDarkAction" class="pr-4 font-semibold" type="filled" icon="expand_more" icon-after>Action</vs-button>
              <vs-dropdown-menu class="adminDropdown">
                <vs-dropdown-item :disabled="selected.length <= 0" @click="suspendAdmins(true)">
                  Suspend
                </vs-dropdown-item>
                <vs-dropdown-item :disabled="selected.length <= 0" @click="suspendAdmins(false)">
                  Unsuspend
                </vs-dropdown-item>
                <vs-dropdown-item :disabled="selected.length <= 0" @click="confirmDelete = true">
                  Delete
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <input maxLength="30" type="text" name="search" class="search px-4 w-1/4 py-3 shadow-lg" placeholder="Search..." @input="getAdminsList('search')" v-model="search"/>
            <div class="verticalCenter">
                <vs-button type="filled" @click="addData">Add Admin</vs-button>
            </div>
        </vs-row>
        <vs-row class="tblBgClrAdmin shadow-lg mx-4">
                <vs-table multiple ref="table" v-model="selected" :max-items="itemsPerPage" :data="adminsList" class="w-full" hoverFlat>
                    <template slot="thead">
                        <vs-th>ACCOUNT NAME</vs-th>
                        <vs-th>EMAIL</vs-th>
                        <vs-th>STATUS</vs-th>
                        <vs-th>LAST LOGIN</vs-th>
                    </template>

                    <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td @click.native.stop="editData(tr)">
                            <p class="font-medium">{{ tr ?  tr.firstName+' '+tr.lastName : '' }}</p>
                        </vs-td>

                        <vs-td @click.native.stop="editData(tr)">
                            <p class="font-medium">{{ tr ?  tr.email : '' }}</p>
                        </vs-td>

                        <vs-td @click.native.stop="editData(tr)">
                            {{ tr.suspended ? 'Suspended' : 'Active' }}
                        </vs-td>

                        <vs-td @click.native.stop="editData(tr)" >
                            <p class="font-medium" v-if="tr.lastLogin">{{ tr.lastLogin | formatLastLogin  }}</p>
                            <p class="font-medium" v-if="!tr.lastLogin">Not Logged In Yet</p>
                        </vs-td>

                        </vs-tr>
                    </tbody>
                    </template>
                </vs-table>
                <vs-row class="my-6 w-full" vs-justify="center" v-if="adminsList && adminsList.length > 0">
                    <div style="width:max-content">
                        <vs-pagination :total="totalPages" v-model="pageIndex" @change="getAdminsList('pagination')" v-show="adminsListHasData"></vs-pagination>
                    </div>
                </vs-row>
        </vs-row>
        <vs-popup class="AdminCover" title="Edit Admin" :active.sync="showEditAdmin">
                <vs-row class="editAdminBg">
                    <vs-row class="p-2">
                        <vs-row class="p-5 pl-0 ml-3 m-5 mt-1">
                                <vs-col vs-lg="8">
                                    <div @click="$refs.uploadEditAdmin.click()" class="uploadLabelAdmin">{{ updateAdmin.photo ? updateAdmin.photo.name : 'Upload Profile Photo' }}</div>
                                    <input type="file" class="hidden" ref="uploadEditAdmin" @change="showEditAdminFile" @click="$refs.uploadEditAdmin.value=null">
                                </vs-col>

                                <vs-col vs-lg="2" class="uploadContainerAdmin">
                                     <div class="btn-addon">
                                      <vs-button size="small" color="primary" @click="$refs.uploadEditAdmin.click()">
                                          <UploadCloudIcon />
                                      </vs-button>
                                    </div>
                                </vs-col>
                                 <vs-col vs-lg="2" class="uploadContainerAdmin" vs-type="flex" vs-justify="space-between">
                                     <!-- <img v-if="previewImage" :src="require('@/assets/images/cross.svg')" @click="clearSelectedImage" class="remove-image"/> -->
                                     <img v-if="previewImage" :src="previewImage" class="selected-image" />
                                     <div v-if="previewImage" @click="clearSelectedImage" class="remove-image">Remove</div>
                                </vs-col>
                                 <vs-row class="pl-1">
                                    <div v-show="errors.photo.success">
                                        <div class="dangerColor mt-3 pl-0">
                                            <span class="ml-0">{{ errors.photo.msg }}</span>
                                        </div>
                                    </div>
                                </vs-row>
                            </vs-row>
                    </vs-row>
                    <vs-col vs-lg="6" vs-sm="12">
                        <vs-row>
                        <div class="ml-5">
                            First Name <span v-if="errors.firstName.success" class="sterik">*</span>
                            <span v-if="!errors.firstName.success"> *</span>                            
                        </div>
                        </vs-row>
                        <vs-input 
                        class="w-full p-2 pl-4"
                        v-model="updateAdmin.fname"
                        :danger="errors.firstName.success"
                        :danger-text="errors.firstName.msg"
                        @input="validateFirstName($event)"
                        @keypress="validateAlpha($event)"
                        maxLength="40"/>
                    </vs-col>
                    <vs-col vs-lg="6" vs-sm="12">
                        <vs-row>
                        <div class="ml-5">
                            Last Name <span v-if="errors.lastName.success" class="sterik">*</span>
                            <span v-if="!errors.lastName.success"> *</span>
                        </div>
                        </vs-row>
                        <vs-input 
                        class="w-full p-2 pl-4" 
                        v-model="updateAdmin.lname"
                        :danger="errors.lastName.success"
                        :danger-text="errors.lastName.msg"
                        @input="validateLastName($event)"
                        @keypress="validateAlpha($event)"
                        maxLength="40"/>
                    </vs-col>
                    <vs-row>
                        <vs-row>
                        <div class="ml-5 mt-4">
                            Email <span v-if="errors.email.success" class="sterik">*</span>
                            <span v-if="!errors.email.success"> *</span>                            
                        </div>
                        </vs-row>
                        <vs-input 
                        class="w-full p-2 pl-4" 
                        v-model="updateAdmin.email"
                        :danger="errors.email.success"
                        :danger-text="errors.email.msg"
                        @input="validateEmail($event)"
                        maxLength="50" />
                    </vs-row>
                    <vs-col vs-lg="6" vs-sm="12">
                            <vs-row>
                            <div class="ml-5 mt-4">
                                New Password <span v-if="errors.password.success" class="sterik">*</span>
                            </div>
                            </vs-row>
                            <vs-input 
                            class="w-full p-2 pl-4" 
                            v-model="updateAdmin.password" 
                            type="password"
                            :danger="errors.password.success"
                            :danger-text="errors.password.msg"
                            @input="validatePassword($event)"
                            maxLength="40"
                           />
                    </vs-col>
                    <vs-col vs-lg="6" vs-sm="12">
                        <vs-row>
                        <div class="ml-5 mt-4">
                            Confirm New Password <span v-if="errors.password2.success" class="sterik">*</span>
                        </div>
                        </vs-row>
                        <vs-input 
                         class="w-full p-2 pl-4"
                          v-model="updateAdmin.confirmP" 
                          type="password"
                          :danger="errors.password2.success"
                            :danger-text="errors.password2.msg"
                            maxLength="40"
                         />
                    </vs-col>
                    <vs-row class="p-5 pl-0 ml-3 m-5" vs-justify="center">
                        <vs-button @click="editAdmin">Save Changes</vs-button>
                    </vs-row>
                </vs-row>
        </vs-popup>
        <vs-popup class="AdminCover" title="Add Admin" :active.sync="addAdmin">
            <vs-row>
                    <vs-row class="p-2">
                        <vs-col vs-lg="6" vs-sm="12">
                            <vs-row>
                            <div class="ml-5">
                                First Name <span v-if="errors.firstName.success" class="sterik">*</span>
                                <span v-if="!errors.firstName.success"> *</span>                            
                            </div>
                            </vs-row>
                            <vs-input  
                            class="w-full p-2 pl-4" 
                            v-model="newAdmin.fname"
                            :danger="errors.firstName.success"
                            :danger-text="errors.firstName.msg"
                             @input="validateFirstName($event)"
                             @keypress="validateAlpha($event)"
                             maxLength="40"/>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12">
                             <vs-row>
                            <div class="ml-5">
                                Last Name <span v-if="errors.lastName.success" class="sterik">*</span>
                                <span v-if="!errors.lastName.success"> *</span>                            
                            </div>
                            </vs-row>
                            <vs-input 
                            class="w-full p-2 pl-4" 
                            v-model="newAdmin.lname"
                            :danger="errors.lastName.success"
                            :danger-text="errors.lastName.msg"
                             @input="validateLastName($event)"
                             @keypress="validateAlpha($event)"
                             maxLength="40"/>
                        </vs-col>
                        <vs-row>
                            <vs-row>
                            <div class="ml-5 mt-4">
                                Email <span v-if="errors.email.success" class="sterik">*</span>
                                <span v-if="!errors.email.success"> *</span>                                                            
                            </div>
                            </vs-row>
                            <vs-input 
                            class="w-full p-2 pl-4" 
                            v-model="newAdmin.email"
                            :danger="errors.email.success"
                            :danger-text="errors.email.msg"
                             @input="validateEmail($event)"
                             maxLength="50" />
                        </vs-row>
                        <vs-col vs-lg="6" vs-sm="12">
                            <vs-row>
                            <div class="ml-5 mt-4">
                                Password <span v-if="errors.password.success" class="sterik">*</span>
                                <span v-if="!errors.password.success"> *</span>                                                                                            
                            </div>
                            </vs-row>
                             <vs-input 
                             class="w-full p-2 pl-4" 
                             v-model="newAdmin.password" 
                             type="password"
                             :danger="errors.password.success"
                            :danger-text="errors.password.msg"
                             @input="validatePassword($event)"
                             maxLength="40"/>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12">
                            <vs-row>
                            <div class="ml-5 mt-4">
                                Confirm New Password <span v-if="errors.password2.success" class="sterik">*</span>
                                <span v-if="!errors.password2.success"> *</span>                                                                                            
                            </div>
                            </vs-row>
                            <vs-input 
                            class="w-full p-2 pl-4" 
                            v-model="newAdmin.confirmP"
                             type="password"
                             :danger="errors.password2.success"
                            :danger-text="errors.password2.msg"
                            maxLength="40"
                            />
                        </vs-col>
                        <vs-row class="p-5 pl-0 ml-3 m-5" vs-justify="center">
                            <vs-col vs-lg="8">
                                <div @click="$refs.uploadAddAdmin.click()" class="uploadLabelAdmin">{{ newAdmin.photo ? newAdmin.photo.name : 'Upload Profile Photo' }}</div>
                                <input type="file" class="hidden" ref="uploadAddAdmin" @change="showAddAdminFile" @click="$refs.uploadAddAdmin.value=null">
                            </vs-col>

                            <vs-col vs-lg="1" class="uploadContainerAdmin">
                                <div class="btn-addon">
                                <vs-button size="small" color="primary" @click="$refs.uploadAddAdmin.click()">
                                    <UploadCloudIcon />
                                </vs-button>
                                </div>
                            </vs-col>
                            <vs-row class="pl-6 ml-6">
                                    <div v-show="errors.photo.success" class="ml-6 pl-6">
                                        <div class="dangerColor mt-3 ml-3 pl-0">
                                            <span class="ml-0">{{ errors.photo.msg }}</span>
                                        </div>
                                    </div>
                                </vs-row>
                        </vs-row>
                        <vs-row class="p-5 pl-0 ml-3 m-5" vs-justify="center">
                            <vs-button @click="addNewAdmin">Create Admin</vs-button>
                        </vs-row>
                    </vs-row>
                </vs-row>
        </vs-popup>
        <vs-popup class="holamundo"  title="Result" :active.sync="addAdminStatus">
            <h5> 
                Admin added successfully
            </h5>
        </vs-popup>
        <vs-popup class="holamundo"  title="Result" :active.sync="updateAdminStatus">
            <h5> 
                Admin updated successfully
            </h5>
        </vs-popup>
        <vs-popup class="holamundo"  title="Status" :active.sync="showDeleteStatus.status">
            <h5> 
                {{ showDeleteStatus.msg }}
            </h5>
        </vs-popup>
        <vs-popup class="holamundo"  title="Status" :active.sync="showSuspendStatus.status">
            <h5> 
                {{ showSuspendStatus.msg }}
            </h5>
        </vs-popup>
        <vs-popup class="holamundo"  title="Status" :active.sync="confirmDelete">
            <h5>Are you sure that you want to delete?</h5>
            <vs-row vs-justify="flex-end">
                <vs-button @click="deleteAdmins" class="mr-4">Yes</vs-button>
                <vs-button @click="confirmDelete = false">No</vs-button>
            </vs-row>
        </vs-popup>
    </vs-row>
</template>

<script>
    import { MenuIcon, UploadCloudIcon } from 'vue-feather-icons';
    import { validateFirstName, validateLastName, validateEmail, validatePassword, validateConfirmPassword,
        validateUploadPhoto,onAddAdmin, validateAlpha
    } from '@/views/admin/validation';

    import EventBus from '@/event-bus.js';
    import { genericErrorMessage, toast } from '@/keys/toast-messages';

    export default {
        components: {
            MenuIcon,
            UploadCloudIcon
        },
        data() {
            return {
                firstRender:false,
                previewImage: '',
                timer: false,
                confirmDelete: false,

                newAdmin: {
                    fname: '',
                    lname: '',
                    email: '',
                    password: '',
                    confirmP: '',
                    photo: ''
                },
                addAdminStatus: false,
                updateAdmin: {
                    id: '',
                    fname: '',
                    lname: '',
                    email: '',
                    password: '',
                    confirmP: '',
                    photo: ''
                },
                updateAdminStatus: false,

                selectedRow: '',
                showEditAdmin: false,
                addAdmin: false,

                adminsList:[],
                search: '',
                adminsListHasData: true,
                pageIndex: 1,
                totalPages: 1,

                selected: [],
                itemsPerPage: 6,
                isMounted: false,

                showDeleteStatus: {
                    msg: '',
                    status: false
                },
                showSuspendStatus: {
                    msg: '',
                    status: false
                },

                errors: {
                    firstName: {
                        msg: '',
                        success: false
                    },
                    lastName: {
                        msg: '',
                        success: false
                    },
                    email: {
                        msg: '',
                        success: false
                    },
                    password: {
                        msg: '',
                        success: false
                    },
                    password2: {
                        msg: '',
                        success: false
                    },
                    photo: {
                        msg: '',
                        success: false
                    }
                },
                validateFirstName,
                validateLastName,
                validateEmail,
                validatePassword,
                validateConfirmPassword,
                validateUploadPhoto,
                onAddAdmin,
                validateAlpha,

                genericErrorMessage,
                toast
            }
        },
        methods: {
            clearSelectedImage(){
                this.updateAdmin.photo = ''
                this.previewImage = ''
            },
            showAddAdminFile(e){
                this.newAdmin.photo = this.$refs.uploadAddAdmin.files[0]
                if(this.newAdmin.photo){
                    this.validateUploadPhoto(this.newAdmin.photo);
                    let format = this.$refs.uploadAddAdmin.files[0].type.split('/').pop();
                    if(this.$refs.uploadAddAdmin.files[0].size/1048576 > this.$maxFileSize){
                        this.errors.photo = {
                            msg: 'Photo size must be less than '+this.$maxFileSize+' MB',
                            success: true
                        }
                    }
                    else {
                        this.errors.photo = {
                            msg: '',
                            success: false
                        }
                        if(!this.$photoFormats.includes(format)){
                            this.errors.photo = {
                                msg: 'Please select a valid photo format',
                                success: true
                            }
                        }
                        else {
                            this.errors.photo = {
                                msg: '',
                                success: false
                            }
                        }
                    }
                }
                else {
                    this.errors.photo = {
                        msg: 'Upload Photo is required',
                        success: true
                    }
                }
            },
            showEditAdminFile(){
                this.updateAdmin.photo = this.$refs.uploadEditAdmin.files[0];
                this.previewImage = URL.createObjectURL(this.updateAdmin.photo)
                if(this.updateAdmin.photo){
                    let format = this.$refs.uploadEditAdmin.files[0].type.split('/').pop();
                    if(this.$refs.uploadEditAdmin.files[0].size/1048576 > this.$maxFileSize){
                        this.errors.photo = {
                            msg: 'Photo size must be less than '+this.$maxFileSize+' MB',
                            success: true
                        }
                    }
                    else {
                        this.errors.photo = {
                            msg: '',
                            success: false
                        }
                        if(!this.$photoFormats.includes(format)){
                            this.errors.photo = {
                                msg: 'Please select a valid photo format',
                                success: true
                            }
                        }
                        else {
                            this.errors.photo = {
                                msg: '',
                                success: false
                            }
                        }
                    }
                }
                else {
                    this.errors.photo = {
                        msg: '',
                        success: false
                    }
                }
            },
            editData(tr) {
                this.selected = [];
                this.updateAdmin = {
                    id: '',
                    fname: '',
                    lname: '',
                    email: '',
                    password: '',
                    confirmP: '',
                    photo: ''
                },
                this.updateAdmin.id = tr._id;
                this.selectedRow = tr;
                this.showEditAdmin = true;
                this.updateAdmin.photo = {
                    name: tr.photo.split('/').pop()
                };
                this.previewImage = this.$ApiKeys.IMAGE_BASE_URL+tr.photo
                this.updateAdmin.fname = tr.firstName;
                this.updateAdmin.lname = tr.lastName;
                this.updateAdmin.email = tr.email;
                this.errors = {
                    firstName: {
                        msg: '',
                        success: false
                    },
                    lastName: {
                        msg: '',
                        success: false
                    },
                    email: {
                        msg: '',
                        success: false
                    },
                    password: {
                        msg: '',
                        success: false
                    },
                    password2: {
                        msg: '',
                        success: false
                    },
                    photo: {
                        msg: '',
                        success: false
                    }
                }
            },   
            addData() {
                this.addAdmin = true;
                this.newAdmin = {
                    fname: '',
                    lname: '',
                    email: '',
                    password: '',
                    confirmP: '',
                    photo: ''
                },
                this.errors = {
                    firstName: {
                        msg: '',
                        success: false
                    },
                    lastName: {
                        msg: '',
                        success: false
                    },
                    email: {
                        msg: '',
                        success: false
                    },
                    password: {
                        msg: '',
                        success: false
                    },
                    password2: {
                        msg: '',
                        success: false
                    },
                    photo: {
                        msg: '',
                        success: false
                    }
                }
            }, 
            async suspendAdmins(status){

                let adminIds = [];
                await this.selected.forEach(function(element, index){
                    adminIds.push(element._id);
                });

                return new Promise((resolve, reject) => {
                    this.$axios.patch(this.$ApiKeys.BASE_URL+this.$EndPoints.SuspendAccounts,
                    adminIds,
                    {
                        params:{
                            suspendUsers: status
                        }
                    }, 
                    ).then(async res => {
                        if(res.data.success == true){
                            this.showSuspendStatus = {
                                msg: res.data.message,
                                status: true
                            };
                            this.getAdminsList();
                        } else {
                            this.toast(this.genericErrorMessage());
                        }
                    }).catch(e => {
                        if(e.response.data.errors.unauthorized){
                            this.showSuspendStatus = {
                                msg: e.response.data.errors.unauthorized,
                                status: true
                            };
                        }
                        else {
                            this.showSuspendStatus = {
                                msg: '',
                                status: false
                            };
                            if(e.response.data.errors.cardId){
                                this.showSuspendStatus = {
                                    msg: e.response.data.errors.cardId,
                                    status: true
                                };
                            }
                            else {
                                this.showSuspendStatus = {
                                    msg: '',
                                    status: false
                                };
                                if(e.response.status !== 401){
                                    this.toast(this.genericErrorMessage());
                                }
                            }
                        }
                    });
                });
            },
            async deleteAdmins(){
                this.confirmDelete = false;
                 if(this.selected.length == 0){
                    this.showDeleteStatus = {
                        msg: 'Please select atleast one request to delete',
                        status: true
                    };
                }
                else {

                    this.$vs.loading({
                        background: 'rgba(1,2,3,.2)'
                    });
                     this.showDeleteStatus = {
                            msg: '',
                            status: false
                        };
                    let adminIds = [];
                    await this.selected.forEach(function(element, index){
                        adminIds.push(element._id);
                    });

                    return new Promise((resolve, reject) => {
                        this.$axios.delete(this.$ApiKeys.BASE_URL+this.$EndPoints.DeleteAdmins,{
                            data: adminIds
                        }, 
                        ).then(async res => {
                            this.$vs.loading.close();
                            if(res.data.success){
                                this.showDeleteStatus = {
                                    msg: res.data.message,
                                    status: true
                                };
                                this.getAdminsList();
                                this.selected = [];
                            } else {
                                this.toast(this.genericErrorMessage());
                            }
                        }).catch(e => {
                            this.$vs.loading.close();
                            if(e.response.data.errors.unauthorized){
                                this.showDeleteStatus = {
                                    msg: e.response.data.errors.unauthorized,
                                    status: true
                                };
                            }
                            else {
                                this.showDeleteStatus = {
                                    msg: '',
                                    status: false
                                };
                                if(e.response.data.errors.cardId){
                                    this.showDeleteStatus = {
                                        msg: e.response.data.errors.userId,
                                        status: true
                                    };
                                }
                                else {
                                    this.showDeleteStatus = {
                                        msg: '',
                                        status: false
                                    };
                                   if(e.response.status !== 401){
                                        this.toast(this.genericErrorMessage());
                                    }  
                                }
                            }
                            
                        });
                    });
                }
            },
            editAdmin(){
                if(onAddAdmin(this,'') && !this.errors.photo.success && !this.errors.firstName.success && !this.errors.lastName.success){
                     this.$vs.loading({
                        background: 'rgba(1,2,3,.2)'
                    });
                    var data = new FormData();
                    data.append('firstname',this.updateAdmin.fname);
                    data.append('lastname',this.updateAdmin.lname);
                    data.append('email',this.updateAdmin.email);
                    this.updateAdmin.password && data.append('newPassword',this.updateAdmin.password);
                    data.append('photo',this.updateAdmin.photo);
                    return new Promise((resolve, reject) => {
                        this.$axios.patch(this.$ApiKeys.BASE_URL
                        +this.$EndPoints.EditAdmin
                        +"/"
                        +this.updateAdmin.id,
                        data,
                        {
                            headers: {
                                'Content-Type':'multipart/form-data'
                            }
                        }).then(async res => {
                            this.$vs.loading.close();
                            this.selected = [];
                            if(res.data.success){
                                this.updateAdminStatus = true;
                                this.showEditAdmin = false,
                                this.getAdminsList();
                            } else {
                                this.toast(this.genericErrorMessage());
                            }
                        }).catch(e => {
                            this.selected = [];
                            this.$vs.loading.close();
                            if(e.response.data.errors.email){
                                this.errors.email = {
                                    msg: e.response.data.errors.email,
                                    success: true
                                }
                            }
                            else {
                                this.errors.email = {
                                    msg: '',
                                    success: false
                                }
                            }
                            if(e.response.data.errors.password){
                                this.errors.password = {
                                    msg: e.response.data.errors.password,
                                    success: true
                                }
                            }
                            else {
                                this.errors.password = {
                                    msg: '',
                                    success: false
                                }
                            }
                            if(e.response.data.errors.unauthorized){
                                this.showEditAdmin = false;
                                this.showDeleteStatus = {
                                    msg: e.response.data.errors.unauthorized,
                                    status: true
                                };
                            }
                            else {
                                this.showDeleteStatus = {
                                    msg: '',
                                    status: false
                                };
                                
                            }
                            if(!e.response.data.errors.email && !e.response.data.errors.password && !e.response.data.errors.unauthorized){
                                if(e.response.status !== 401){
                                    this.toast(this.genericErrorMessage());
                                }
                            }
                        });
                    });
                }
            },
            addNewAdmin(){
                if(onAddAdmin(this,'add') && !this.errors.photo.success && !this.errors.firstName.success && !this.errors.lastName.success){
                     this.$vs.loading({
                        background: 'rgba(1,2,3,.2)'
                    });
                    var data = new FormData();
                    data.append('firstName',this.newAdmin.fname);
                    data.append('lastName',this.newAdmin.lname);
                    data.append('email',this.newAdmin.email);
                    data.append('password',this.newAdmin.password);
                    // data.append('password2',this.newAdmin.confirmP);
                    data.append('photo',this.newAdmin.photo);
                    data.append('userType','admin')
                 
                    return new Promise((resolve, reject) => {
                        this.$axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.AddAdmin,data, { 
                            headers: {
                                'Content-Type':'multipart/form-data'
                            }
                        }).then(async res => {
                            this.$vs.loading.close();
                            if(res.data.success == true){
                                this.addAdminStatus = true;
                                this.addAdmin = false;
                                this.getAdminsList();
                            } else {
                                this.toast(this.genericErrorMessage());
                            }
                        }).catch(e => {
                            this.$vs.loading.close();
                            if(e.response.data.errors.email){
                                this.errors.email = {
                                    msg: e.response.data.errors.email,
                                    success: true
                                }
                            }
                            else {
                                this.errors.email = {
                                    msg: '',
                                    success: false
                                }
                            }
                            if(e.response.data.errors.password){
                                this.errors.password = {
                                    msg: e.response.data.errors.password,
                                    success: true
                                }
                            }
                            else {
                                this.errors.password = {
                                    msg: '',
                                    success: false
                                }
                            }
                            if(!e.response.data.errors.email && !e.response.data.errors.password){
                                if(e.response.status !== 401){
                                    this.toast(this.genericErrorMessage());
                                }
                            }
                        });
                    });
                }
            },
            getAdminsList(name){
                if(name=='pagination' && this.firstRender==false){
                    this.firstRender=true
                    return
                }
                clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                    this.selected = [];
                    this.$vs.loading.close();
                    this.$vs.loading({
                        background: 'rgba(1,2,3,.2)'
                    });
                    return new Promise(async (resolve, reject) => {
                        await this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.Accounts, { 
                        params: {
                            userType:'admin',
                            populateProfiles:false,
                            exportCsv:false,
                            keyword: this.search,
                            page: name == 'search' ? 1 : this.pageIndex,
                            perPage: this.itemsPerPage
                        }
                        }).then(async res => {
                            this.$vs.loading.close();
                            if(res.data.success){
                                if(name == 'search'){
                                    this.pageIndex = 1;
                                }
                                if(res.data.data[0].metaData.length<=0 || res.data.data[0].users.length<=0){
                                this.adminsList = [],
                                this.adminsListHasData = false
                                }
                                this.totalPages = Math.ceil(res.data.data[0].metaData[0].total / this.itemsPerPage);
                                resolve(
                                    this.adminsList = res.data.data[0].users,
                                    this.adminsListHasData = true
                                );
                            } else {
                                this.toast(this.genericErrorMessage());
                            }
                        }).catch(e => {
                            this.$vs.loading.close();
                            if(e.response.status == 404){
                                this.adminsListHasData = false;
                                this.adminsList = [];
                            }
                            if(e.response.status !== 401 && e.response.status !== 404){
                                this.toast(this.genericErrorMessage());
                            }
                        });
                    });
                },500)
            }
        },
        created() {
            this.getAdminsList();
            EventBus.$emit('resetToggleGroup',true);
        },
        mounted() {
            this.isMounted = true;
        }
    }
</script>

<style> 
    @import './style.css';
</style>


